__turbopack_context__.v({
  "animate-learn-more-popover-in": "wbkv0a_animate-learn-more-popover-in",
  "animate-learn-more-popover-out": "wbkv0a_animate-learn-more-popover-out",
  "animate-popover-in": "wbkv0a_animate-popover-in",
  "animate-popover-in-keyframes": "wbkv0a_animate-popover-in-keyframes",
  "animate-popover-out": "wbkv0a_animate-popover-out",
  "animate-popover-out-keyframes": "wbkv0a_animate-popover-out-keyframes",
  "base-animation": "wbkv0a_base-animation",
  "closing": "wbkv0a_closing",
  "learn-more-animation": "wbkv0a_learn-more-animation",
});
